export const LEAF = 0;
export const SNOW = 1;
export const LOCKED = 2;
